module.exports = __webpack_public_path__ + "static/srxp-aa8d0029dcb35776296b69afcaf3baa7.webp";